<template>
  <section>
    <h2 class="mt-5">
      <i18n path="common.options" />
    </h2>
    <table class="table table-striped option-table">
      <thead>
        <tr>
          <th>
            <i18n path="common.tbTitle.name" />
          </th>
          <th>
            <i18n path="common.tbTitle.type" />
          </th>
          <th>
            <i18n path="common.tbTitle.desc" />
          </th>
          <th>
            <i18n path="common.tbTitle.required" />
          </th>
          <th>
            <i18n path="common.tbTitle.default" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>v-model/value</td>
          <td>
            <div>object</div>
            <div>string[]</div>
          </td>
          <td>
            <i18n path="region.option.selected" />
            <ul class="mt-3">
              <li>
                <code>province</code> 省、直辖市及特别行政区编码
              </li>
              <li>
                <code>city</code> 城市编码
              </li>
              <li>
                <code>area</code> 区/县编码
              </li>
              <li>
                <code>town</code> 乡镇编码
              </li>
            </ul>
            <p>
              <i18n path="region.option.cityPickerSelected" />
            </p>
            <code>['city code1', 'city code2', ...]</code>
            <p class="mt-3">
              <strong>
                <i18n path="common.example" />
              </strong>:
            </p>
            <p>用于 'RegionSelects', 'RegionGroup', 'RegionText', 'RegionColumns' 等模块的格式:</p>
            <code>
              <pre class="text-danger">
{
  province: '350000',
  city: '350100',
  area: '350103',
  town: '350103012'
}</pre>
            </code>
            <p>用于 'RegionCityPicker' 模块的数据格式:</p>
            <code>['110000', '130200', '140100']</code>
          </td>
          <td>false</td>
          <td>undefined</td>
        </tr>
        <tr>
          <td>blank</td>
          <td>boolean</td>
          <td>
            <i18n path="region.option.blank" />
          </td>
          <td>false</td>
          <td>true</td>
        </tr>
        <tr>
          <td>disabled</td>
          <td>boolean</td>
          <td>
            <i18n path="region.option.disabled" />
          </td>
          <td>false</td>
          <td>false</td>
        </tr>
        <tr>
          <td>city</td>
          <td>boolean</td>
          <td>
            <i18n path="region.option.city" />
          </td>
          <td>false</td>
          <td>true</td>
        </tr>
        <tr>
          <td>area</td>
          <td>boolean</td>
          <td>
            <i18n path="region.option.area" />
          </td>
          <td>false</td>
          <td>true</td>
        </tr>
        <tr>
          <td>town</td>
          <td>boolean</td>
          <td>
            <i18n path="region.option.town" />
          </td>
          <td>false</td>
          <td>false</td>
        </tr>
        <tr>
          <td>search</td>
          <td>boolean</td>
          <td>
            <i18n path="region.option.search" />
          </td>
          <td>false</td>
          <td>true</td>
        </tr>
        <tr>
          <td>language</td>
          <td>string</td>
          <td>
            <i18n path="region.option.language" />
            <ul class="mt-3">
              <li><code class="me-3">cn</code> <i18n path="common.lang.cn" /></li>
              <li><code class="me-3">en</code> <i18n path="common.lang.en" /></li>
            </ul>
          </td>
          <td>false</td>
          <td>true</td>
        </tr>
        <tr>
          <td>separator</td>
          <td>string</td>
          <td>
            <i18n path="region.option.separator" />
          </td>
          <td>false</td>
          <td>''</td>
        </tr>
        <tr>
          <td>overflow</td>
          <td>boolean</td>
          <td>
            <i18n path="region.option.overflow" />
            <div>true: 显示所有选中城市名称</div>
            <div>false: 选中的城市多于两个时，仅显示前两个城市名称，其他城市会被收起</div>
          </td>
          <td>false</td>
          <td>false</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {

}
</script>
